var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.500000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 1.818182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63727273,3.63909091 C4.63954545,3.63909091 5.45545455,2.82318182 5.45545455,1.82090909 C5.45545455,0.818636364 4.63954545,0.00272727273 3.63727273,0.00272727273 C2.635,0.00272727273 1.81909091,0.818636364 1.81909091,1.82090909 C1.81909091,2.82318182 2.635,3.63909091 3.63727273,3.63909091 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63727273,4.09363636 C1.49590909,4.09363636 0.000909090909,5.215 0.000909090909,6.82090909 L0.000909090909,7.27545455 L7.27363636,7.27545455 L7.27363636,6.82090909 C7.27363636,5.215 5.77863636,4.09363636 3.63727273,4.09363636 Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "10.0009091 1.36636364 8.63727273 1.36636364 8.63727273 0.00272727273 7.72818182 0.00272727273 7.72818182 1.36636364 6.36454545 1.36636364 6.36454545 2.27545455 7.72818182 2.27545455 7.72818182 3.63909091 8.63727273 3.63909091 8.63727273 2.27545455 10.0009091 2.27545455"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/user-add.ba36eeee09b51d493093ed248e33b819.svg";
export { ForwardRef as ReactComponent };